import React, { useMemo, useState } from 'react'

import { OPERATION_MODE } from '@laramie/ui';
import { buildCellAVMR } from "../../../utils"
import {TIPS} from "../../../../../consts/tips";

import { FormError, InputNumber, InputPercent, TableCustom, FormLabel, Modal } from "../../../../../components/common"
import { useFormErrors } from '../../../../../components/hooks';

const DefinicionIntereses = ({ data, setData, params, setPendingChange }) => {
    const [edittingInteres, setEdittingInteres] = useState()
    const [mode, setMode] = useState()

    const filteredData = useMemo(() => !data ? [] : data.filter(x => x.state !== 'r'), [data])

    const onAdd = (interes) => {
        setEdittingInteres({
            id: -Date.now(),
            idPlanPagoDefinicion: parseInt(params.id),
            cuotaDesde: 0,
            cuotaHasta: 0,
            porcentajeInteres: 0,
            state: 'a',
        })
        setMode('add')
    }

    const onView = (interes) => {
        setEdittingInteres(interes)
        setMode('view')
    }

    const onModify = (interes) => {
        setEdittingInteres(interes)
        setMode('modify')
    }

    const onRemove = (interes) => {
        setData(data.map(x => x.id === interes.id ? {...x, state: 'r'} : x))
        setPendingChange(true)
    }

    const { errorOf, validate, reset } = useFormErrors(getErrors)

    function getErrors() {
        const errors = {}
        if (!edittingInteres) return errors

        if (!(edittingInteres.cuotaDesde > 0)) errors.cuotaDesde = 'Ingresá un número mayor a cero'
        if (!(edittingInteres.cuotaHasta > 0)) errors.cuotaHasta = 'Ingresá un número mayor a cero'

        return errors
    }

    const onClickModalAccept = () => {
        if (!validate()) return

        if (mode === 'add') {
            setData([...data, edittingInteres])
        }

        else if (mode === 'modify') {
            setData(data.map(x => x.id === edittingInteres.id ? {...edittingInteres, state: edittingInteres.state === 'a' ? 'a' : 'm',} : x))
        }

        setMode(null)
        reset()

        setPendingChange(true)
    }

    const onClickModalCancel = () => {
        setEdittingInteres(null)
        setMode(null)
        reset()
    }
    
    return (
        <div className="col-12 col-md-6">

            <div className="col-12 p-top-15">
                <label className="form-label">Interés</label>
                <TableCustom
                    showFilterGlobal={false}
                    floatingDownloadCSVButton={true}
                    className='TableCustomBase'
                    columns={[
                        { Header: 'Cuota desde', accessor: 'cuotaDesde', width: '30%' },
                        { Header: 'Cuota hasta', accessor: 'cuotaHasta', width: '30%' },
                        { Header: 'Porcentaje', accessor: 'porcentajeInteres', width: '30%' },
                        buildCellAVMR({ onAdd, onView, onModify, onRemove, readOnly: params.mode === OPERATION_MODE.VIEW }),
                    ]}
                    data={filteredData}
                />
            </div>
    
            {!!mode && (
                <Modal
                    size="md"
                    title="Interés"
                    tipName={TIPS.NAME.MODALS.INTERES_DEFINICION_MODAL}
                    onEscape={onClickModalCancel}
                    body={(
                                <div className="row">
                                    <div className="col-12 col-md-4">
                                        <FormLabel htmlFor="cuotaDesde" required>Cuota desde</FormLabel>
                                        <InputNumber
                                            name="cuotaDesde"
                                            placeholder=""
                                            className={`form-control ${errorOf('cuotaDesde') ? 'is-invalid' : ''}`}
                                            value={edittingInteres.cuotaDesde}
                                            onChange={({ target }) => setEdittingInteres(prev => ({...prev, cuotaDesde: target.value}))}
                                            precision={0}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError message={errorOf('cuotaDesde')} />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <FormLabel htmlFor="cuotaHasta" required>Cuota hasta</FormLabel>
                                        <InputNumber
                                            name="cuotaHasta"
                                            placeholder=""
                                            className={`form-control ${errorOf('cuotaHasta') ? 'is-invalid' : ''}`}
                                            value={edittingInteres.cuotaHasta}
                                            onChange={({ target }) => setEdittingInteres(prev => ({...prev, cuotaHasta: target.value}))}
                                            precision={0}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError message={errorOf('cuotaHasta')} />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label htmlFor="procentajeInteres" className="form-label">Porcentaje interés</label>
                                        <InputPercent
                                            name="porcentajeInteres"
                                            placeholder=""
                                            className="form-control"
                                            value={edittingInteres.porcentajeInteres}
                                            onChange={({ target }) => setEdittingInteres(prev => ({...prev, porcentajeInteres: target.value}))}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError />
                                    </div>
                                </div>
                    )}
                    footer={(<>
                                {mode !== 'view' && (
                                <>
                                    <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onClickModalCancel}>Cancelar</button>
                                    <button className="btn btn-primary" data-dismiss="modal" onClick={onClickModalAccept}>Aceptar</button>
                                </>
                                )}
                                {mode == 'view' && (
                                    <div className="width-100p f-align">
                                        <button className="btn back-button" data-dismiss="modal" onClick={onClickModalCancel}>Volver</button>
                                    </div>
                                )}
                    </>)}
                />
            )}
        </div>
    )
}

export default DefinicionIntereses